import type { MaintenanceMessage } from "../model/MaintenanceMessage";
import API, { responseOf } from "./base";

export const create = (
  message: MaintenanceMessage,
): Promise<MaintenanceMessage> =>
  responseOf(API.post("/maintenance-messages/create-message", message));

export const getById = (id: string): Promise<MaintenanceMessage> =>
  responseOf(API.get(`/maintenance-messages/${id}/find-message`));

export const update = (
  id: string,
  message: MaintenanceMessage,
): Promise<MaintenanceMessage> =>
  responseOf(API.put(`/maintenance-messages/${id}/update-message`, message));

export const remove = async (id: string): Promise<void> => {
  await API.delete(`/maintenance-messages/${id}/delete-message`);
};

export const getAll = (): Promise<MaintenanceMessage[]> =>
  responseOf(API.get("/maintenance-messages/get-all-messages"));
